import React from 'react'
import { Box, Typography, styled } from '@mui/material'
import Pic from '../../resources/IMG_5555.jpeg'
import { Column, Row, SwapRow } from '../../components/Common/CommonComponents'
import { CalendarMonth, Science, Build, Waves, WbSunny, MedicalServices } from '@mui/icons-material'
import Footer from '../../components/Footer/Footer'
import GreenPic1 from '../../resources/green1.jpeg'
import GreenPic2 from '../../resources/green2.jpeg'
import GreenPic3 from '../../resources/green3.jpeg'

const PageContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  justifyItems: 'flex-start'
}))

const PicContainer = styled(Box)(({ theme }) => ({
  borderRadius: '12px',
  flex: 1,
}))

const WavesIcon = styled(Waves)(({ theme }) => ({
  height: '100px',
  width: '100px',
  color: 'rgba(0, 0, 0, .1)',
}))

const TextContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'center',
  padding: '36px 25px'
}))

const getColor = (color?: string, theme?: any) => {
  if (color === 'light') return theme.palette.primary.light
  if (color === 'blue') return theme.palette.primary.main
  if (color === 'dark-grey') return theme.palette.grey[300]
  return theme.palette.grey[50]
}

const InfoContainer = styled(Box)<{ color?: string }>(({ theme, color }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: getColor(color, theme),
  padding: '24px',
  borderRadius: '12px',
  border: `1px solid ${theme.palette.grey[300]}`,
  gap: '24px',
  flex: '1',
  [theme.breakpoints.down('sm')]: {
    padding: '12px'
  },
}))

const IconContainer = styled(Box)<{ color?: string }>(({ theme, color }) => ({
  backgroundColor: color === 'red' ? theme.palette.secondary.shade?.p4 : theme.palette.primary.shade?.p4,
  color: color === 'red' ? theme.palette.secondary.main : theme.palette.primary.main,
  padding: '8px',
  borderRadius: '12px',
  display: 'inline-block',
}))

const ServicesPage = () => (
  <PageContainer>
    <SwapRow size='md'>
      <TextContainer flex={{xs: 1, md: .8}}>
        <Typography variant="body2" color="secondary.main" marginBottom="8px">
          AQUATIC EXCELLENCE
        </Typography>
        <Typography variant='h4' color="text.primary">
          Curated Care for
        </Typography>
        <Row gap="8px">
          <Typography variant='h4' color="text.primary">
            Your
          </Typography>
          <Typography variant='h4' color="tertiary.main">
            Private Oasis
          </Typography>
        </Row>
        <Typography variant='body1' color="text.primary" marginTop="12px">
          From chemical precision to seasonal transitions, we ensure your water remains a pristine sanctuary of clarity and comfort.
        </Typography>
      </TextContainer>
        <PicContainer padding={{ xs: '12px', sm: '36px' }}>
          <img src={Pic} height="300px" width="100%" alt="sample" style={{ objectFit: "cover", borderRadius: '12px' }} />
        </PicContainer>
    </SwapRow>
    <SwapRow size="md" gap="24px" padding={{ xs: '12px', sm: '12px 36px' }}>
      <InfoContainer>
        <Row justifyContent="space-between">
          <Column gap="12px">
            <Box>
              <IconContainer>
                <CalendarMonth />
              </IconContainer>
            </Box>
            <Typography variant='h6' color="text.primary">
              Weekly / Forntnightly / Monthly Maintenance
            </Typography>
            <Typography variant='body1' color="text.primary">
              We meticulously monitor and adjust your pool's chemical levels, ensuring optimal water quality and a safe swimming environment.
            </Typography>
          </Column>
          <Row alignItems="center">
            <WavesIcon />
          </Row>
        </Row>
      </InfoContainer>
      <InfoContainer color="blue">
        <Box>
          <IconContainer>
            <Build />
          </IconContainer>
        </Box>
        <Typography variant='h6' color="background.default">
          Equipment Installation
        </Typography>
        <Typography variant='body1' color="background.default">
          Our expert team ensures seamless installation of pool equipment, from pumps to filters to heaters, guaranteeing optimal performance and longevity.
        </Typography>
      </InfoContainer>
    </SwapRow>
    <SwapRow size="md" gap="24px" padding={{ xs: '12px', sm: '12px 36px' }}>
      <InfoContainer color="light">
        <Box>
          <IconContainer>
            <Science />
          </IconContainer>
        </Box>
        <Typography variant='h6' color="text.primary">
          Chemical Balancing
        </Typography>
        <Typography variant='body1' color="text.primary">
          Scientific precision in every drop. We monitor pH, chlorine, and alkalinity levels to ensure therapeutic-grade water quality.
        </Typography>
      </InfoContainer>
      <InfoContainer color="dark-grey">
        <Box>
          <IconContainer>
            <WbSunny />
          </IconContainer>
        </Box>
        <Typography variant='h6' color="text.primary">
          Seasonal Opening / Closing
        </Typography>
        <Typography variant='body1' color="text.primary">
          We ensure a smooth transition for your pool with our seasonal opening and closing services, maintaining optimal water quality and equipment performance throughout the year.
        </Typography>
      </InfoContainer>
    </SwapRow>
    <Box padding={{ xs: '12px', sm: '12px 36px' }} marginBottom="24px">
      <InfoContainer>
        <Box>
          <IconContainer color="red">
            <MedicalServices />
          </IconContainer>
        </Box>
        <Typography variant='h6' color="text.primary">
          Green Pool Recovery
        </Typography>
        <Typography variant='body1' color="text.primary">
          We specialise in transforming green, algae-infested pools back to crystal-clear perfection, restoring your aquatic oasis with expert care and precision.
        </Typography>
                <SwapRow size="md" gap="10px">
            <PicContainer>
              <img src={GreenPic1} height="400px" width="100%" alt="sample" style={{ objectFit: "cover", borderRadius: '12px' }} />
            </PicContainer>
            <PicContainer>
              <img src={GreenPic2} height="400px" width="100%" alt="sample" style={{ objectFit: "cover", borderRadius: '12px' }} />
            </PicContainer>
            <PicContainer>
              <img src={GreenPic3} height="400px" width="100%" alt="sample" style={{ objectFit: "cover", borderRadius: '12px' }} />
            </PicContainer>
          </SwapRow>
      </InfoContainer>
    </Box>
    <Footer />
  </PageContainer>
)

export default ServicesPage